import {
    fetchResponses,
    updateMetaTags,
    checkItemExists,
    reversed
} from "../script.js";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp, faTowerBroadcast, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from "react-router-dom";

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Modal from 'react-bootstrap/Modal';
import Card from 'react-bootstrap/Card';

export default function Search(props) {
    const navigate = useNavigate();

    const [similarItems, setsimilarItems] = useState([]);

    const urlParams = new URLSearchParams(useLocation().search);
    const queryParam = urlParams.get('query');

    let userInputField;
    let loadingIndicator;
    let spinnerOverlay;

    useEffect(() => {
        userInputField = document.getElementById('user-input');
        loadingIndicator = document.getElementById('loading');
        spinnerOverlay = document.getElementById('spinner-overlay');

        // Handle button click
        document.getElementById('btn-query').addEventListener('click', handleUserInput);

        // Handle Enter key press
        userInputField.addEventListener('keydown', function (event) {
            if (event.key === 'Enter') {
                handleUserInput(event);
            }
        });

        if (queryParam) {
            document.title = `6 Hats - ${decodeURIComponent(queryParam)}`;
            userInputField.value = decodeURIComponent(queryParam);
            userInputField.classList.add('loading');
            loadingIndicator.style.display = 'inline';
            loadingIndicator.style.margin = 'auto';
            spinnerOverlay.style.display = 'inline';
            spinnerOverlay.style.margin = 'auto';
            // Load similar queries
            try {
                fetch(`https://sixhats-backend.onrender.com/similar?query=${queryParam}`).then(response => {
                    userInputField.classList.remove('loading');
                    loadingIndicator.style.display = 'none';
                    spinnerOverlay.style.display = 'none';

                    if (response.ok) {
                        response.json().then(responseData => {
                            console.log(responseData)
                            setsimilarItems(responseData);
                        });
                    } else {
                        console.log("Error getting response");
                        return;
                    }
                })
            } catch (error) {
                console.error('Error updating stream:', error);
                return;
            }
        }

        // Call the function whenever the page content changes
        // Update meta tags when the DOM is fully loaded
        updateMetaTags();
    }, []);

    const handleUserInput = async function (event) {
        event.preventDefault();
        const userInput = userInputField.value.trim();

        if (userInput !== '') {
            navigate(`/search?query=${userInput}`, { replace: true });
            window.location.reload();
        }
    }

    function generateItem() {
        if (!props.loggedInEmail) {
            navigate("/account");  // Navigate to the loggin page
        } else {
            const NAMESPACE_URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8'; // UUIDv5 Namespace URL
            /*global uuid*/
            const guid = uuid.v5(similarItems.query, NAMESPACE_URL);

            if (similarItems.query !== '') {
                let spinnerOverlay = document.getElementById("spinner-overlay");
                let userInputField = document.getElementById('user-input');
                let loadingIndicator = document.getElementById('loading');

                spinnerOverlay.style.display = 'flex';
                const encodedQuery = encodeURIComponent(similarItems.query);

                checkItemExists(guid).then(
                    itemExists => {
                        if (itemExists) {
                            navigate(`/?item=${guid}`, { replace: true });
                            window.location.reload();
                        } else {
                            fetchResponses(encodedQuery, loadingIndicator, spinnerOverlay, userInputField, navigate);
                        }
                    }
                )
            }
        }
    }

    return (
        <div className="content-div">
            {!queryParam ?
                <div style={{
                    width: "100%",
                    height: "100%",
                    flex: 1,
                    backgroundImage: `url("6hats_background.jpg")`,
                    backgroundPositionX: "50%",
                    backgroundPositionY: "50%",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    boxSizing: "border-box"
                }}/> : null
            }
            {similarItems.similar_queries ?
                <>
                    <div className="stream-view">
                        {similarItems.query ? <h3 id="title-field" style={{ marginInline: "50px" }}>{similarItems.query}</h3> : null}

                        <hr style={{ height: "4px", width: "100%" }} />
                        <div id="table_items" className="stream-table">
                            {similarItems.similar_queries ?
                                similarItems.similar_queries.map((streamItem, i) => {
                                    return <Card onClick={() => {
                                        navigate(`/s/${streamItem.stream_guid}?item=` + streamItem.item_guid, { replace: true });
                                    }}>
                                        <div className={'stream-table-row ' + (i % 2 != 0 ? 'dark-background' : '')}>
                                            <div className="stream-table-left">
                                                <FontAwesomeIcon icon={faTowerBroadcast} size="lg" />
                                            </div>
                                            {/* Center div - display item information */}
                                            <div className="stream-table-center">
                                                <h6> {streamItem.query} </h6>
                                            </div>
                                            {

                                            }
                                        </div>
                                    </Card>
                                }) : null}

                            {similarItems.similar_queries.length == 0 ?
                                <div className="stream-table-center">
                                    <p id="no_items"> No similar queries found... Do you want to generate a new response? </p></div> : null
                            }
                        <Card className="conspicuous-button-card" onClick={() => { generateItem() }}>
                            <div className="stream-table-row">
                                <div className="stream-table-left">
                                    <FontAwesomeIcon icon={faArrowUp} size="lg" />
                                </div>
                                <div className="stream-table-center">
                                    <h6>{props.loggedInEmail ? "Generate the response" : "Log in to generate responses"}</h6>
                                </div>
                            </div>
                        </Card>
                        </div>
                        <div style={{height:"35vh"}}/>
                    </div >
                </> : null}

            {/*<!-- Text box container fixed at the bottom of the page -->*/}
            <div className="textbox-container">
                <textarea id="user-input" rows="2" placeholder="6Hats – AI answers. You save. Experts bring nuance."></textarea>
                {/*<!-- Upward arrow button on the right side -->*/}
                <button className="arrow-button" id="btn-query">
                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                </button>
            </div>

            <span id="loading" className="center-screen" style={{ display: "none" }}>Loading...</span>

            {/*<!-- Spinner overlay -->*/}
            <div id="spinner-overlay" className="spinner-overlay" style={{ display: "none" }}>
                <i className="fas fa-spinner fa-spin fa-3x" style={{ color: "gray" }}></i>
            </div>
        </div>
    );
}
